import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, ViewChildren, QueryList, OnDestroy, ChangeDetectorRef} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subscription, take } from 'rxjs';
import { Images } from '../../shared/utils/image-enum';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { CommonService } from 'src/app/shared/service/common.service';
import { HttpStatusCode } from '@angular/common/http';
import { sendOtpDto } from 'src/app/shared/model/sendOtp-dto';
import {
  LoggedInUserKeys,
  LoggedInUserService,
} from 'src/app/shared/service/logged-in-user.service';
import { NgOtpInputComponent } from 'ng-otp-input';
import { AuthService } from '../auth.service';
import { Title } from '@angular/platform-browser';
import { AppUsersDto } from 'src/app/shared/model/app-users-dto';
import { ThemeService } from 'src/app/shared/service/colourTheme.service';
import { DOMAIN_CONFIG } from 'domain-config';
import { ChangePasswordFormComponent } from 'src/app/shared/component/popup-forms/change-password-form/change-password-form.component';
import { ShowpopupDirective } from 'src/app/shared/directives/showpopup.directive';
import { environment } from 'src/environments/environment';
import * as Sentry from "@sentry/angular";

export function nameValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return { required: true };

    const value = control.value.trim();
    if (value.length === 0) {
      return { emptyName: true };
    }
    const nameRegex = /^[A-Za-z]+( [A-Za-z]+)*$/;
    return nameRegex.test(value) ? null : { invalidName: true };
  };
}
export function customEmailValidator(
  control: AbstractControl
): ValidationErrors | null {
  const value = control.value;

  if (!value) return null; // let required handle empty

  const emailRegex =
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return emailRegex.test(value)
    ? null
    : { invalidEmail: true };
}
@Component({
    selector: 'app-signin',
    templateUrl: './signin.component.html',
    styleUrls: ['./signin.component.scss'],
    standalone: false
})

export class SigninComponent implements OnInit, AfterViewInit, OnDestroy {
  enableStep1: boolean = true;
  enableStep2: boolean = false;
  enableVerifyAndContinue: boolean;
  isLoginScreenVisible :boolean = false;
  enteredMobileNo: number;
  sendOtpDto: sendOtpDto = new sendOtpDto();
  otpSignIn!: FormGroup;
  termsAndConditionModal: boolean;
  ModalHeading: string;
  @ViewChild('otpInput', { read: ElementRef }) otpInput: ElementRef;
  @ViewChild('otpInput') otpInputRef: NgOtpInputComponent;
  contactNumberLength: number;
  passcode: any;
  loginUser: AppUsersDto;
  inviteToken: string;
  theme: boolean = false;
  inviteDriveId: string;
  @ViewChild(ShowpopupDirective, { static: false }) loadPopup!: ShowpopupDirective;
  @ViewChildren('carouselVideo') carouselVideos!: QueryList<ElementRef<HTMLVideoElement>>;
  @ViewChildren('carouselGif') carouselGifs!: QueryList<ElementRef<HTMLImageElement>>;
  resetPasswordForm: FormGroup;
  private closeSubscription!: Subscription;
  confirmpassword: string;
  currentSlide: number = 0;

  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      color: 'black',
      background: 'transparent',
     // 'width': '40px',
     'height': '36px'
    },
  };

  constructor(
    private toaster: ToastrService,
    private router: Router,
    public service: CommonService,
    private _formBuilder: FormBuilder,
    private loggedInUserService: LoggedInUserService,
    private _authService: AuthService,
    private titleService: Title,
    private route: ActivatedRoute,
    public themeService: ThemeService,
    private cd: ChangeDetectorRef
  ) {
    this.titleService.setTitle(`${service.Enums.IQIGAI} || Sign-in`);
    let currentDomain = window.location.hostname;
    this.currentDomain = DOMAIN_CONFIG[currentDomain]?.ssoLoginEnabled;

    this?.route?.queryParamMap.subscribe((params) => {
      const driveId = params.get('driveId');
      if (driveId) {
        sessionStorage.setItem('inviteDriveId', driveId);
        this.inviteDriveId = driveId;
      }else{
        sessionStorage.removeItem('token');
      }
    });
    const fullPath = this.route.snapshot['_routerState'].url;
    if (fullPath.includes('callback')) {
      const pathAfterSso = fullPath.replace('/callback', '');
      this._authService.ssoCallback(pathAfterSso);
      return;
    }

    this.otpSignIn = this._formBuilder.group({
      mobileNumber: ['', Validators.required], // For phone login
      phoneCode: ['+91', Validators.required],
      email: ['', [Validators.required, Validators.email]], // For email login
      password: ['', [Validators.required, Validators.minLength(6)]], // Password field
    });

    this.signUpForm = this._formBuilder.group(
      {
        username: ['', [Validators.required , this.customNameValidations.bind(this)] ],
        email: ['', [Validators.required, Validators.email,customEmailValidator]],
        mobile: ['', [Validators.required, Validators.minLength(10)]],
        phoneCode: ['+91', Validators.required],
        password: ['', [Validators.required, this.passwordPolicyValidator]],
        confirmPassword: ['', Validators.required],
        // termsAccepted: [false, Validators.requiredTrue],
        privacyAccepted: [false, Validators.requiredTrue],
      },
      {
        validators: this.passwordMatchValidator.bind(this),
      }
    );
  }
  currentDomain: boolean = false;
  timeLeft: number = 30;
  intervalId: number;
  loading: boolean;
  timer$: Observable<number> = new Observable((observer) => {
    this.intervalId = window.setInterval(() => {
      this.timeLeft--;
      observer.next(this.timeLeft);
      if (this.timeLeft <= 0) {
        observer.complete();
      }
    }, 1000);

    return () => {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    };
  });
  timerSubscription?: Subscription;

  public get Images() {
    return Images;
  }

  private readonly PADDING_KEY = 'f360';
  newUser: boolean = false; // to show registration form
  ssoUserDetails: any; // Contains the user's information from the SSO login

  registrationForm: FormGroup;
  profileForm: FormGroup;
  showImageForValidEmail = false;
  enableStepEmail: boolean = false;
  enteredEmail: string = '';
  signUpVisible = false;
  signUpForm: FormGroup;
  forgotPasswordForm: FormGroup;
  forgotPasswordFormState: boolean = false;
  countryCodes: string[] = ['+91', '+63'];
  enteredPhoneCode: string = '+91';
  signupPhoneCode: string = '+91';
  phoneCodeDropdownOpen: boolean = false;

  // togglePhoneCodeDropdown() {
  //   this.phoneCodeDropdownOpen = !this.phoneCodeDropdownOpen;
  // }

  closePhoneCodeDropdown() {
    this.phoneCodeDropdownOpen = false;
  }

  selectPhoneCode(form: FormGroup, code: string, event?: Event) {
    event?.stopPropagation();
    form.get('phoneCode')?.setValue(code);
    this.applyMobileValidators(form);
    this.phoneCodeDropdownOpen = false;
  }

  minMobileLengthFor(code: string): number {
    return code === '+63' ? 7 : 10;
  }

  isValidMobileLength(form: FormGroup, length: number): boolean {
    const code = form.get('phoneCode')?.value || '+91';
    const min = this.minMobileLengthFor(code);
    return code === '+63' ? length >= min : length === min;
  }

  applyMobileValidators(form: FormGroup) {
    const ctrl = form.get(form.contains('mobile') ? 'mobile' : 'mobileNumber');
    if (!ctrl) return;
    const code = form.get('phoneCode')?.value || '+91';
    ctrl.setValidators([
      Validators.required,
      Validators.minLength(this.minMobileLengthFor(code)),
    ]);
    ctrl.updateValueAndValidity();
  }
  ngOnInit() {
    console.log('signin ngOnInit fired');
    this.startAutoPlay();
    this.theme = this.themeService.isBlueTheme();
    sessionStorage.setItem('cameFromApp', 'true');
    this.route.queryParams.subscribe((params) => {
      const data = params['data']; // Query param to get user details
      if (data) {
        this.loading = true;
        const decodedString = atob(data.replace(/-/g, '+').replace(/_/g, '/'));

        if (
          !decodedString.startsWith(this.PADDING_KEY) ||
          !decodedString.endsWith(this.PADDING_KEY)
        ) {
          throw new Error('Invalid data format');
        }

        const jsonStr = decodedString.slice(
          this.PADDING_KEY.length,
          -this.PADDING_KEY.length
        );
        let subId = JSON.parse(jsonStr);
        this._authService.getToken(subId.sub).subscribe({
          next: (res) => {
            console.log('Token Response:', res);
            if (res) {
              res.authToken = res.accessToken;
              this.loggedInUserService.setLoggedInUser(
                LoggedInUserKeys.LOGGED_IN_USER,
                res
              );
              this.ssoUserDetails = res;
              this.newUser = true;
              if (!this.ssoUserDetails.name) {
                this.isOverlayVisible = true;
                this.prefillForm();
              } else {
                this.getSSOUserDetails();
              }
            }
          },
          error: (err) => {
            console.error('Error fetching token:', err);
            this.loading = false;
            this.router.navigate(['/sign-in']);
          },
        });
      }
    });

    this.loginUser = this.loggedInUserService.getLoggedInUser(
      LoggedInUserKeys.LOGGED_IN_USER
    );
    this._authService.redirectUserLoggedInOrNot('signin');

    this.inviteToken = sessionStorage.getItem('token');
    this.basicFormValidation();
    this.resetFormCreate();
    const ssoTrigger = localStorage.getItem('SSO_TRIGGER') === 'true';
    if(!ssoTrigger){
       this.reloadPageOnLoad();
    }
  }

  passwordMatchValidator(form: FormGroup) {
    const password = form.get('password')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;

    if (password && confirmPassword && password !== confirmPassword) {
      form.get('confirmPassword')?.setErrors({ passwordMismatch: true });
    } else {
      const errors = form.get('confirmPassword')?.errors;
      if (errors && errors['passwordMismatch']) {
        delete errors['passwordMismatch'];
        if (Object.keys(errors).length === 0) {
          form.get('confirmPassword')?.setErrors(null);
        }
      }
    }

    return null;
  }

  prefillForm() {
    // Pre-fill the registration form if user data is available
    if (this.ssoUserDetails) {
      this.registrationForm.patchValue({
        email: this.ssoUserDetails?.email || '',
        mobileNumber: this.ssoUserDetails?.mobileNumber || '',
        name: this.ssoUserDetails?.name || '',
      });
    }
    this.loading = false;
  }

  private base64UrlToUint8Array(base64Url: string): Uint8Array {
    const padding = '='.repeat((4 - (base64Url.length % 4)) % 4);
    const base64 = (base64Url + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }
  basicFormValidation() {
    this.profileForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email,customEmailValidator]],
      phoneCode: ['+91', Validators.required],
      mobileNumber: ['', [Validators.required, Validators.minLength(10)]],
      // password: ['', [Validators.required]],
    });
  }

  checkValidEmail(emailValue: string) {
    if (!this.profileForm.get('email').hasError('invalidEmail') && emailValue) {
      this.showImageForValidEmail = true;
    } else {
      this.showImageForValidEmail = false;
    }
  }

  contactNumberLengthForReset: number;
  contactNumberLengthForSignup: number;
  getContactLength(event: any) {
    const value = event.target.value;

    // If any alphabet exists, clear entire input
    if (/[a-zA-Z]/.test(value)) {
      event.target.value = '';
      this.signUpForm.get('mobileNumber')?.setValue('', { emitEvent: false });
      this.contactNumberLength = 0;
      return;
    }

    // Allow only digits (numbers)
    const cleaned = value.replace(/[^0-9]/g, '');

    if (value !== cleaned) {
      event.target.value = cleaned;
      this.signUpForm
        .get('mobileNumber')
        ?.setValue(cleaned, { emitEvent: false });
    }

    this.contactNumberLength = cleaned.length;
  }

  getContactLengthForReset(event: any) {
    this.contactNumberLengthForReset = event.target.value.length;
  }

  getContactLengthForSignup(event: any) {
    this.contactNumberLengthForSignup = event.target.value.length;
  }

  private normalizePhoneCode(code: string | null | undefined): string {
    const trimmed = typeof code === 'string' ? code.trim() : '';
    return trimmed || '+91';
  }

  onSubmit(value: any, data: string) {
    this.loading = true;
    if (this.isPhoneLogin) {
      console.log(value, 'phone login');
      const phoneCode = this.normalizePhoneCode(
        value?.phoneCode ?? this.otpSignIn.get('phoneCode')?.value
      );
      let payloadData = {
        mobileNumber: value.mobileNumber,
        phoneCode,
        password: btoa(value.password),
      };
      this.saveProfile(payloadData);
    } else {
      console.log(value, 'email login');
      let payloadData = {
        email: value.email,
        password: btoa(value.password),
      };
      this.saveProfile(payloadData);
    }

    // if (this.enteredEmail.length > 0) {
    //   this.saveProfile(this.enteredEmail);
    // } else {
    //   this.sendOtpDto = value;
    //   if (this.isPhoneLogin && value.mobileNumber.length < 10) {
    //     this.toaster.error('Please Enter your 10 digit Mobile Number', 'Error');
    //     return;
    //   } else {
    //     this.enteredMobileNo = value.mobileNumber;
    //     this.service.sendOtp(this.sendOtpDto).subscribe({
    //       next: (response) => {
    //         if (response.statusCode === HttpStatusCode.Ok) {
    //           sessionStorage.setItem('SSO_LOGIN', 'false');
    //           this.toaster.success(response.message, 'Success');
    //           this.otpInputRef?.setValue('');
    //           this.enableStep2 = true;
    //           this.enableStep1 = false;
    //           this.timeLeft = 30;
    //           this.startTimer();
    //           if (data !== 'RESENDOTP') {
    //             this.enableVerifyAndContinue = false;
    //           }
    //           setTimeout(() => {
    //             const inputElements: NodeList =
    //               this.otpInput.nativeElement.querySelectorAll('input');
    //             if (inputElements && inputElements.length > 0) {
    //               (inputElements[0] as HTMLInputElement).focus();
    //             }
    //             setTimeout(() => {
    //               const inputElements: NodeList =
    //                 this.otpInput.nativeElement.querySelectorAll('input');
    //               if (inputElements && inputElements.length > 0) {
    //                 (inputElements[0] as HTMLInputElement).focus();
    //               }
    //             });
    //           });
    //         }
    //       },
    //     });
    //   }
    // }
  }

  startTimer() {
    if (!this.timerSubscription || this.timerSubscription.closed) {
      this.timeLeft=30;
      this.timerSubscription = this.timer$.pipe(take(30)).subscribe();
    }
  }

  onChangePasscode(passcode: any) {
    this.passcode = passcode;
    if (passcode.length === 6) {
      this.enableVerifyAndContinue = true;
    } else {
      this.enableVerifyAndContinue = false;
    }
  }

  changeContact() {
    if (this.enteredEmail.length > 0) {
      this.enableStepEmail = true;
      this.enableStep2 = false;
    } else {
      this.enableStep2 = false;
      this.enableStep1 = true;
    }
    this.timerSubscription?.unsubscribe();
  }

  numberOnly(event) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  verifyPasscode() {
    this.loading = true;
    if (this.enteredEmail.length > 0) {
      this.sendOtpDto.email = this.enteredEmail;
      this.sendOtpDto.sendOtpWithEmail = true;
    }
    this.sendOtpDto.otp = this.encryptValue(this.passcode);

    this.service.validateOtp(this.sendOtpDto).subscribe({
      next: (response) => {
        this.loading = false;

        if (response.statusCode !== HttpStatusCode.Ok) return;

        this.toaster.success(response.message, 'Success');
        const userData = response.data;
        this.loggedInUserService.setLoggedInUser(
          LoggedInUserKeys.LOGGED_IN_USER,
          userData
        );

        this.handleNavigation(userData);
      },
      error: (error) => {
        console.error(error);
        this.loading = false;
      },
    });
  }

  handleNavigation(userData: any) {
    Sentry.setUser({ id: userData.id, email: userData.email });
    Sentry.setTag('userId', userData.id);
    Sentry.logger.info('User logged In', {
      userId: String(userData.id),
      email: String(userData.email),
    });
    const {
      isFirstTimeLogin,
      isProfileDetailsUpdated,
      isProfileDetailsSkipped,
      hasRegisteredDrives
    } = userData;

    const profileCompleted = isProfileDetailsUpdated;

   if (!profileCompleted) {
     return this.router.navigate([this.service.Navigations.NEW_PROFILE_DETAILS]);
    } else if (hasRegisteredDrives && !this.inviteToken) {
     return this.router.navigate([this.service.Navigations.DASHBOARD_ASSESSMENT]);
    } else if (hasRegisteredDrives && this.inviteToken) {
    return  this.navigateToInvite();
    } else if (!hasRegisteredDrives && !this.inviteToken) {
    return  this.router.navigate([this.service.Navigations.DASHBOARD]);
    } 
    else if (!hasRegisteredDrives && this.inviteToken) {
    return  this.navigateToInvite();
    }
  }

  navigateToInvite() {
    this.router.navigate(['/examination/test/invite'], {
      queryParams: { token: this.inviteToken },
    });
  }

  encryptValue(data: string) {
    return btoa(data);
  }

  openTermsAndConditionModal(value: any,url: string) {
    // Redirect to the external siteURL
    window.open(url, '_blank');
    // this.service.open(value);
  }

  carouselActive(event: Event) {
    const clickedBullet = event.target as HTMLLabelElement;
    const allBullets = document.querySelectorAll('.carousel-bullet');
    if (!(clickedBullet.classList[0] == 'carousel-indicators')) {
      allBullets.forEach((bullet) => {
        bullet.classList.remove('active');
      });
      clickedBullet.classList.add('active');
    }
  }

  isOverlayVisible = false;
  triggerSSOLogin() {
    this.loading = true;
    this.loggedInUserService.clearEntireStorage();
    // window.location.href =
    //   'https://ap-south-1lhpo6asbw.auth.ap-south-1.amazoncognito.com/oauth2/authorize?response_type=code&client_id=1emfq3ij0gc3gdgo87i3mcru4j&scope=email%20openid%20phone%20profile&state=7Sa-XnpUsumj_9dKe6sv_26m2WBrgrw5LHw4pFWdIwE%3D&redirect_uri=http://localhost:9564/login/oauth2/code/cognito&nonce=tbzCBf_7pV8OhJv_gR5-8GUcZxDSA50w4cRYmTRwTxQ';

    sessionStorage.setItem('SSO_LOGIN', 'true');
    localStorage.setItem('SSO_TRIGGER', 'true');
    this._authService.getSSOLogin('candidate');

    // this._authService.getSSOLogin().subscribe({
    //   next: (response) => {
    //     console.log('Full Response:', response);

    //     // Debugging the response status and headers
    //     console.log('Response Status:', response.status);
    //     console.log('Response Headers:', response.headers);
    //     console.log('Response Body:', response.body);

    //     // Check if it's a successful response
    //     if (response.status === HttpStatusCode.Ok) {
    //       if (response.body && response.body.url) {
    //       }
    //     } else if (response.status === 302) {
    //       // Handle 302 - Check for Location header
    //       const redirectUrl = response.headers.get('Location');
    //       console.log('Redirect URL from Location header:', redirectUrl);

    //       if (redirectUrl) {
    //         window.location.href = redirectUrl;
    //       } else {
    //         console.error('No Location header found in 302 response');
    //         this.toaster.error('Redirect URL not found', 'Error');
    //       }
    //     } else {
    //       // Handle non-302 status codes
    //       this.toaster.error(
    //         response.body?.message || 'Unknown error',
    //         'Error'
    //       );
    //     }

    //     this.isOverlayVisible = true;
    //   },
    //   error: (err) => {
    //     console.error('Error during SSO login:', err);
    //     this.toaster.error(
    //       'Something went wrong while trying to login.',
    //       'Error'
    //     );
    //   },
    // });
  }

  closeOverlay() {
    this.isOverlayVisible = false;
  }

  onRegister() {
    // Validate form before submitting
    if (this.registrationForm.valid) {
      const formData = this.registrationForm.value;
      // Make API call to register the user
      let payloadData = {
        email: formData.email,
        name: formData.name,
        sub: this.ssoUserDetails?.sub,
      };
      this._authService.getSSOInfo(payloadData).subscribe({
        next: (response: any) => {
          if (response?.statusCode === HttpStatusCode.Ok) {
            this.toaster.success('Registration Successful', 'Success');
            this.isOverlayVisible = false; // Close the form after successful registration
            const userData = response?.data;
            userData.authToken = this.ssoUserDetails?.accessToken;
            this.loggedInUserService.setLoggedInUser(
              LoggedInUserKeys.LOGGED_IN_USER,
              userData
            );

            if (
              response?.data?.userRole === 'FRACTAL_ADMIN' ||
              response?.data?.userRole === 'FRACTAL_HR' ||
              response?.data?.userRole === 'PROJECT_MANAGER'
            ) {
              const targetRoute =
              response.data.userRole === 'PROJECT_MANAGER'
                ? this.service.resolveLoginPath(
                    this.service.Navigations.AI_MATCHING,
                    userData.isPmViewEnabled,
                  )
                : response.data.userRole === 'FRACTAL_ADMIN'
                  ? this.service.Navigations.ADMIN_USER_DASHBOARD
                  : this.service.resolveLoginPath(
                      this.service.Navigations.HR_USER_DASHBOARD,
                      userData.isPmViewEnabled,
                    );

              this.router.navigateByUrl(targetRoute);
            } else {
              this.handleNavigation(userData);
            }
          }
        },
        error: (err) => {
          this.toaster.error('Error registering user', 'Error');
        },
      });
    } else {
      this.toaster.error('Please fill in all the fields', 'Error');
    }
  }

  getSSOUserDetails() {
    let payloadData = {
      email: this.ssoUserDetails?.email,
      name: this.ssoUserDetails?.name,
      sub: this.ssoUserDetails?.sub,
    };
    this._authService.getSSOInfo(payloadData).subscribe({
      next: (response: any) => {
        const userData = response.data;
        userData.authToken = this.ssoUserDetails?.accessToken;
        this.loggedInUserService.setLoggedInUser(
          LoggedInUserKeys.LOGGED_IN_USER,
          userData
        );

        if (
          response?.data?.userRole === 'FRACTAL_ADMIN' ||
          response?.data?.userRole === 'FRACTAL_HR'
        ) {
          const targetRoute =
            response.data.userRole === 'FRACTAL_ADMIN'
              ? this.service.Navigations.ADMIN_USER_DASHBOARD
              : this.service.resolveLoginPath(
                  this.service.Navigations.HR_USER_DASHBOARD,
                  userData.isPmViewEnabled,
                );

          this.router.navigateByUrl(targetRoute);
        } else {
          this.handleNavigation(userData);
        }
      },
      error: (err) => {
        this.toaster.error('Error registering user', 'Error');
      },
    });
  }

  payloadForEmail: any;
  totalLoginAttempts: number = 5;
  attemptedCount: number = 0;
  isUserTriesLogin: boolean;
 
  saveProfile(value: any) {
    try {
    this.service.candidateLogin(value).subscribe({
      next: (response: any) => {
        if (response.statusCode !== HttpStatusCode.Ok) {
          this.loading = false;
          return;
        }
        if (response.statusCode === HttpStatusCode.Ok) {
          this.toaster.success(response.message, 'Success');
          console.log(response, 'response from save profile');
          this.loading = false;
          this.toaster.success(response.message, 'Success');
          const userData:any = response.data;
          this.loggedInUserService.setLoggedInUser(
            LoggedInUserKeys.LOGGED_IN_USER,
            userData
          );
          this.service._profileImage.next(userData?.profilePicture?.filePreviewUrl ?? null);
          if(!userData.isEmailVerified){
            this.router.navigate([this.service.Navigations.VERIFY_EMAIL]);
          }else{
           // userData.isSystemPassword
            if(userData?.isSystemPassword){
              this.openChangePasswordPopup();
            }else{
              this.handleNavigation(userData);
            }
          }
          // setTimeout(() => {
          //   const inputElements: NodeList =
          //     this.otpInput.nativeElement.querySelectorAll('input');
          //   if (inputElements && inputElements.length > 0) {
          //     (inputElements[0] as HTMLInputElement).focus();
          //   }
          // });
        }
      },
      error: (err) => {
        if(err.error && err.error.statusCode === HttpStatusCode.BadRequest){
          this.toaster.error(err.error.message, 'Error');
          this.isUserTriesLogin = true;
          this.attemptedCount = err?.error?.data ?? 0;
        }else if (err.error && err.error.statusCode === HttpStatusCode.Locked) {
          this.isUserTriesLogin = true;
          this.attemptedCount = err?.error?.data ?? 0;
          this.toaster.error(err.error.message, 'Error');
        }
        this.loading = false;
      },
    });
    } catch (error) {
        if (error.error && error.error.statusCode === HttpStatusCode.Locked) {
          this.attemptedCount = error?.error?.data ?? 0;
        }
    }
  }

  enableEmailform() {
    this.forgotPasswordForm = this._formBuilder.group(
      {
        password: ['', [Validators.required, this.passwordPolicyValidator]],
        confirmPassword: ['', Validators.required],
        otp: [''], // if you want to store OTP in form
      },
      {
        validators: this.passwordMatchValidator.bind(this),
      }
    );

    this.enableStepEmail = true;
    this.enableStep1 = false;
    this.enableStep2 = false;
  }

  openSignUpForm() {
    this.signUpVisible = true;
    this.enableStep1 = false;
  }
  removeReadonly(event: any) {
    event.target.removeAttribute('readonly');
  }

  closeSignUpForm() {
    this.signUpVisible = false;
  }

  closeSignInForm() {
    this.signUpVisible = false;
    this.enableStep1 = true;
  }
  isPhoneLogin: boolean = true;
  isPhoneLoginReset: boolean = true;
  toggleLoginMethod() {
    this.isPhoneLogin = !this.isPhoneLogin;
    this.contactNumberLength = 0;
    this.otpSignIn.reset();
    const emailCtrl = this.otpSignIn.get('email');
    const mobileCtrl = this.otpSignIn.get('mobileNumber');
    const phoneCodeCtrl = this.otpSignIn.get('phoneCode');

    if (this.isPhoneLogin) {
      mobileCtrl.setValidators([Validators.required, Validators.minLength(10)]);
      emailCtrl.clearValidators();
      emailCtrl.setValue('');
      phoneCodeCtrl.setValidators([Validators.required]);
      phoneCodeCtrl.updateValueAndValidity();
      phoneCodeCtrl.setValue('+91');
    } else {
      emailCtrl.setValidators([Validators.required, Validators.email]);
      mobileCtrl.clearValidators();
      mobileCtrl.setValue('');
    }

    emailCtrl.updateValueAndValidity();
    mobileCtrl.updateValueAndValidity();
  }

  toggleLoginMethodReset() {
    this.isPhoneLoginReset = !this.isPhoneLoginReset;
    if (this.isPhoneLoginReset) {
      this.profileForm.get('phoneCode')?.setValue('+91');
      this.profileForm.get('phoneCode')?.updateValueAndValidity();
    }
  }

  termsAndConditionsChecked: boolean;
  privacyPolicyChecked: boolean;

  // Since terms and conditions checkbox is combined with privacy policy as per new design, commenting out terms and conditions checkbox function

  // checkBoxTermsAndConditions(event) {
  //   this.termsAndConditionsChecked = event.target.checked;
  // }

  checkBoxPrivacyPolicy(event) {
    this.privacyPolicyChecked = event.target.checked;
  }

  isPhoneOtpOnMail: boolean = false;
  isStaticOtp: boolean = false;
  isStaticOtpEmail: boolean = false;
  staticOtpValue = environment.STATIC_OTP;
  isBothUnreachable: boolean = false;
  isStaticFromPhone = false;
  isStaticFromEmail = false;
  getOTPForResetPassword(value: any) {
    this.loading = true;
    if (this.isPhoneLoginReset) {
      this.enteredMobileNo = value.mobileNumber;
      const phoneCode = this.normalizePhoneCode(
        value?.phoneCode ?? this.profileForm.get('phoneCode')?.value
      );
      
      this.payloadForEmail = {
        mobileNumber: this.profileForm.get('mobileNumber').value,
        phoneCode,
      };
    } else {
      this.enteredEmail = value.email;
      this.payloadForEmail = {
        email: this.profileForm.get('email').value,
        sendOtpWithEmail: true,
      };
    }
    this.service.forgotPasswordRequest(this.payloadForEmail).subscribe({
      next: (response: any) => {
        if (response.statusCode === HttpStatusCode.Ok) {
          sessionStorage.setItem('SSO_LOGIN', 'false');
          const data = response.data || {};

          // Success flags
          const phoneOtpSuccess = data.phoneOtp === true;
          const emailOtpSuccess = data.emailOtp === true;

          // Static flags
          this.isStaticFromPhone = data.staticOtp === true;
          this.isStaticFromEmail = data.staticOtpEmail === true;

          // Exception case
          this.isPhoneOtpOnMail = data.phoneOtpOnMail === true;

          // 🔥 FINAL STATIC DECISION
          this.isStaticOtp =
            !this.isPhoneOtpOnMail &&
            (this.isStaticFromPhone || this.isStaticFromEmail);

          this.forgotPasswordFormState = true;
          this.startTimer();
          this.enableStepEmail = false;
        } else {
          this.toaster.error(response.message, 'Error');
        }
      },
      error: (error) => {
        console.error(error);
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      },
    });
  }

  resetPassword() {
    this.loading = true;
    let payload: any = {};
    if (this.isPhoneLoginReset) {
      payload.mobileNumber = this.payloadForEmail.mobileNumber;
      payload.phoneCode = this.normalizePhoneCode(this.payloadForEmail.phoneCode);
      payload.password = this.encryptValue(
        this.forgotPasswordForm.get('password').value
      );
      payload.otp = this.encryptValue(this.forgotPasswordForm.get('otp').value);
    } else {
      payload.email = this.payloadForEmail.email;
      payload.password = this.encryptValue(
        this.forgotPasswordForm.get('password').value
      );
      payload.otp = this.encryptValue(this.forgotPasswordForm.get('otp').value);
    }
    payload.otp = this.encryptValue(this.forgotPasswordForm.get('otp').value);
    payload.otp = this.encryptValue(this.forgotPasswordForm.get('otp').value);
    payload.password = this.encryptValue(
      this.forgotPasswordForm.get('password').value
    );

    this.service.forgotPasswordOtpVerify(payload).subscribe({
      next: (response) => {
        this.loading = false;

        this.toaster.success('Password reset successful', 'Success');
        this.enableStep1 = true;
        this.forgotPasswordFormState = false;
        this.enableStepEmail = false;
        this.isUserTriesLogin = false;
      },
      error: (error) => {
        console.error(error);
        this.loading = false;
      },
    });
  }

  onChangePasscodeForForgotPassword(passcode: any) {
    this.passcode = passcode;
    if (passcode.length === 6) {
      this.enableVerifyAndContinue = true;
      this.forgotPasswordForm.patchValue({ otp: this.passcode });
    } else {
      this.enableVerifyAndContinue = false;
    }
  }

  changeCredForOtp() {
    this.forgotPasswordFormState = false;
    this.enableStepEmail = true;
    this.forgotPasswordForm.reset();
    this.enableVerifyAndContinue = false;
  }

  emailOtpRequired = false;
  phoneOtpRequired = false;

  emailVerified = false;
  phoneVerified = false;

  email = '';
  mobile = '';

  showOtpVerification = false;

  // For timers
  emailTimeLeft = 30;
  phoneTimeLeft = 30;

  // For enabling verify buttons
  emailEnableVerify = false;
  phoneEnableVerify = false;

  emailOtp = '';
  phoneOtp = '';

  signupFormPayload: any;
  isPhoneOtpOnMailSignup = false;
  isSignUpStaticOtp = false;
  isSignUpStaticOtpEmail = false;
  staticSignUpOtpValue = environment.STATIC_OTP;
  onSignUp() {
    if (this.signUpForm.invalid) {
      this.toaster.error('Please fill in all the fields', 'Error');
      return;
    }
    this.loading = true;
    const formData = this.signUpForm.value;
    this.signupPhoneCode = formData.phoneCode || '+91';

    this.signupFormPayload = {
      fullName: formData.username,
      email: formData.email,
      mobileNumber: formData.mobile,
      phoneCode: this.normalizePhoneCode(formData.phoneCode),
      password: btoa(formData.password),
      confirmPassword: btoa(formData.confirmPassword),
      privacyPolicyChecked: formData.privacyAccepted,
      // termsAndConditionsChecked: formData.termsAccepted,
      termsAndConditionsChecked: true, // Since terms and conditions checkbox is removed, we are sending this as true
      otpFor: 'BOTH',
    };

    this.service.signUpUser(this.signupFormPayload).subscribe({
      next: (response: any) => {
        if (response?.statusCode === HttpStatusCode.Ok) {
          this.toaster.success('Sign Up Successful', 'Success');

          this.signUpVisible = false;
          this.loading = false;
          this.emailOtpRequired = response?.data?.emailOtp || false;
          this.phoneOtpRequired = response?.data?.phoneOtp || false;

          this.isPhoneOtpOnMailSignup = response?.data?.phoneOtpOnMail === true;
          this.isSignUpStaticOtp = response?.data?.staticOtp === true;
          this.isSignUpStaticOtpEmail = response?.data?.staticOtpEmail === true;
          this.email = formData.email;
          this.mobile = formData.mobile;

          this.emailVerified = false;
          this.phoneVerified = false;

          this.showOtpVerification = true;
          this.isUserTriesLogin = false;

          if (this.emailOtpRequired) this.startEmailTimer();
          if (this.phoneOtpRequired) this.startPhoneTimer();
        } else {
          this.toaster.error(response.message, 'Error');
        }
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  // onEmailOtpChange(code: string) {
  //   this.emailOtp = code;
  //   if (code.length === 6) {
  //     this.verifyEmailOtp();
  //   }
  // }

  // onPhoneOtpChange(code: string) {
  //   console.log(code, 'phone otp code');

  //   this.phoneOtp = code;
  //   if (code.length === 6) {
  //     this.verifyPhoneOtp();
  //   }
  // }

  startEmailTimer() {
    this.emailTimeLeft = 30;
    const interval = setInterval(() => {
      this.emailTimeLeft--;
      if (this.emailTimeLeft <= 0) clearInterval(interval);
    }, 1000);
  }

  startPhoneTimer() {
    this.phoneTimeLeft = 30;
    const interval = setInterval(() => {
      this.phoneTimeLeft--;
      if (this.phoneTimeLeft <= 0) clearInterval(interval);
    }, 1000);
  }

  onEmailOtpChange(otp: string) {
    this.emailOtp = otp;
  }

  onPhoneOtpChange(otp: string) {
    this.phoneOtp = otp;
  }

  verifyEmailOtp() {
    this.loading = true;
    const payload = {
      email: this.email,
      sendOtpWithEmail: true,
      emailOtp: this.emailOtp,
    };

    this.service.verifySignUpOtp(payload).subscribe({
      next: (response) => {
        if (response.statusCode === HttpStatusCode.Ok) {
          this.toaster.success('Email OTP Verified', 'Success');
          this.emailVerified = true;
          this.userData = response.data;
          this.loading = false;
        }
      },
      error: (error) => {
        this.loading = false;
        console.error(error);
      },
    });
  }

  userData: any;
  verifyPhoneOtp() {
    this.loading = true;
    const payload = {
      phoneCode: this.signupPhoneCode,
      mobileNumber: this.mobile,
      phoneOtp: this.phoneOtp,
      isPhoneOtpSent: true,
    };

    this.service.verifySignUpOtp(payload).subscribe({
      next: (response) => {
        if (response.statusCode === HttpStatusCode.Ok) {
          this.toaster.success('Phone OTP Verified', 'Success');
          this.phoneVerified = true;
          this.userData = response.data;
          this.loading = false;
        }
      },
      error: (error) => {
        this.loading = false;
        console.error(error);
      },
    });
  }

  allOtpVerified() {
    if (this.emailOtpRequired && !this.emailVerified) return false;
    if (this.phoneOtpRequired && !this.phoneVerified) return false;
    return true;
  }

  allOtpEntered() {
    if (this.emailOtpRequired && this.emailOtp.length !== this.config.length)
      return false;
    if (this.phoneOtpRequired && this.phoneOtp.length !== this.config.length)
      return false;

    return true;
  }

  completeSignUp() {
    this.loading = true;

    const payload = {
      phoneCode: this.signupPhoneCode,
      mobileNumber: this.mobile,
      email: this.email,
      sendOtpWithEmail: this.emailOtpRequired,
      phoneOtp: this.phoneOtp,
      emailOtp: this.emailOtp,
      isPhoneOtpSent: this.phoneOtpRequired,
    };

    this.service.verifySignUpOtp(payload).subscribe({
      next: (res) => {
        if (res.statusCode === HttpStatusCode.Ok) {
          this.toaster.success('Signup completed', 'Success');
          this.loggedInUserService.setLoggedInUser(
            LoggedInUserKeys.LOGGED_IN_USER,
            res.data
          );
          this.handleNavigation(res.data);
        }
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        console.error(err);
        this.toaster.error('Incorrect OTPs. Please try again.', 'Error');
      },
    });
  }

  resendEmailOtp() {
    const formData = this.signUpForm.value;
    this.loading = true;
    let payload = {
      fullName: formData.username,
      email: formData.email,
      mobileNumber: formData.mobile,
      phoneCode: this.normalizePhoneCode(formData.phoneCode),
      privacyPolicyChecked: formData.privacyAccepted,
      // termsAndConditionsChecked: formData.termsAccepted,
      termsAndConditionsChecked: true, // Since terms and conditions checkbox is removed, we are sending this as true
      otpFor: 'EMAIL',
    };

    this.service.generateSignUpOtp(payload).subscribe({
      next: () => {
        this.loading = false;
        this.startEmailTimer();
        this.toaster.success('Email OTP sent again', 'Success');
      },
      error: (error) => {
        this.loading = false;
      },
    });
  }

  resendPhoneOtp() {
    const formData = this.signUpForm.value;
    this.loading = true;
    let payload = {
      fullName: formData.username,
      email: formData.email,
      mobileNumber: formData.mobile,
      phoneCode: this.normalizePhoneCode(formData.phoneCode),
      privacyPolicyChecked: formData.privacyAccepted,
      // termsAndConditionsChecked: formData.termsAccepted,
      termsAndConditionsChecked: true, // Since terms and conditions checkbox is removed, we are sending this as true
      otpFor: 'PHONE',
    };

    this.service.generateSignUpOtp(payload).subscribe({
      next: () => {
        this.loading = false;
        this.startPhoneTimer();
        this.toaster.success('Mobile OTP sent again', 'Success');
      },
      error: (error) => {
        this.loading = false;
      },
    });
  }

  openLoginForm() {
    this.enableStep1 = true;
    this.signUpVisible = false;
    this.showOtpVerification = false;
    this.enableStepEmail = false;
  }

  resendOtpForForgotPassword() {
    this.loading = true;
    this.service.forgotPasswordRequest(this.payloadForEmail).subscribe({
      next: (response) => {
        if (response.statusCode === HttpStatusCode.Ok) {
          sessionStorage.setItem('SSO_LOGIN', 'false');
          this.toaster.success('OTP resent successfully', 'Success');
          this.startTimer();
        } else {
          this.toaster.error(response.message, 'Error');
        }
      },
      error: (error) => {
        console.error(error);
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      },
    });
  }

  showPassword: boolean = false;
  showPasswordSignup: boolean = false;
  showPasswordSignupConfirm: boolean = false;
  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  togglePasswordSignup() {
    this.showPasswordSignup = !this.showPasswordSignup;
  }

  togglePasswordSignupConfirm() {
    this.showPasswordSignupConfirm = !this.showPasswordSignupConfirm;
  }

  isLoginValid() {
    if (this.isPhoneLogin) {
      return (
        this.otpSignIn.get('mobileNumber').valid &&
        this.otpSignIn.get('phoneCode').valid &&
        this.otpSignIn.get('password').valid
      );
    }
    return (
      this.otpSignIn.get('email').valid && this.otpSignIn.get('password').valid
    );
  }

  showPasswordForgotPassword: boolean = false;
  showPasswordForgotPasswordConfirm: boolean = false;
  togglePasswordForgotPassword() {
    this.showPasswordForgotPassword = !this.showPasswordForgotPassword;
  }

  togglePasswordForgotPasswordConfirm() {
    this.showPasswordForgotPasswordConfirm =
      !this.showPasswordForgotPasswordConfirm;
  }

  passwordPolicyValidator(control: AbstractControl) {
    const value = control.value || '';

    const errors: any = {};

    if (value.length < 8) {
      errors.minLength = true;
    }
    if (!/[A-Z]/.test(value)) {
      errors.uppercase = true;
    }
    if (!/[a-z]/.test(value)) {
      errors.lowercase = true;
    }
    if (!/[0-9]/.test(value)) {
      errors.number = true;
    }
    if (!/[!@#$%^&*(),.?":{}|<>_\-]/.test(value)) {
      errors.special = true;
    }

    return Object.keys(errors).length ? errors : null;
  }
  customNameValidations(control: AbstractControl): {[key: string]: any} | null {
    const value = control.value || '';
    const specialCharRegex = /[^A-Za-z\s]/;
    const nameRegex = /^[A-Za-z]+( [A-Za-z]+)*$/;
    // Check if empty
    if (!value || value.trim().length === 0) {
      return { emptyName: true };
    }
    else if (specialCharRegex.test(value)) {
      return { specialCharacters: true };
    }
    
    // Check for multiple consecutive spaces
    // if (/\s{2,}/.test(value)) {
    //   return { multipleSpaces: true };
    // }

    else if (value !== value.trim()) {
      return { extraSpaces: true };
    }
    
    // Check for valid name pattern (must start and end with letters)
    else if (!nameRegex.test(value.trim())) {
      return { invalidName: true };
    }
    
    return null;
  }
  
  remainingLoginAttempts() {
    const remaining = this.totalLoginAttempts - this.attemptedCount;
    return remaining > 0 ? remaining : 0;
  }

  resetFormCreate() {
    this.resetPasswordForm = this._formBuilder.group(
      {
        email: [''],
        oldPassword: ['', [Validators.required]],
        newPassword: ['', [Validators.required, this.passwordValidator]],
        confirmPassword: ['', Validators.required],
      },
      { validators: this.passwordMatchingValidatior }
    );
  }

  passwordMatchingValidatior: ValidatorFn = (
    control: AbstractControl
  ): ValidationErrors | null => {
    const password = control.get('newPassword');
    const confirmPassword = control.get('confirmPassword');
    return password?.value === confirmPassword?.value
      ? null
      : { notmatched: true };
  };

  passwordValidator(control: AbstractControl): ValidationErrors | null {
    // oldPattern  = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#$%^&*()_+])[A-Za-z0-9!@#$%^&*()_+]{8,}$/
    const passwordPattern =
      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[!@#$%^&*()_+])[\w!@#$%^&*()_+]{8,}$/;
    if (!passwordPattern.test(control.value)) {
      return { invalidPassword: true };
    }
    return null;
  }

  openChangePasswordPopup() {
  const hostViewContainerRef = this.loadPopup.viewPopup;
  
  if (hostViewContainerRef) {
    hostViewContainerRef.clear();
    
    const componentRef = hostViewContainerRef.createComponent(ChangePasswordFormComponent);
    
    this.closeSubscription = componentRef.instance.close.subscribe(() => {
      this.closeSubscription.unsubscribe();
      hostViewContainerRef.clear();
    });
    
    this.closeSubscription = componentRef.instance.confirmPasswordCheck.subscribe((el) => {
      this.confirmpassword = el;
    });
    
    componentRef.instance.resetPasswordForm = this.resetPasswordForm;
    
    if (this.loginUser) {
      componentRef.instance.getLoginEmail = this.loginUser.email;
    }
  }
}
  

  reloadPageOnLoad() {
      // Check if we need to do a hard reload on first open
     const reloadKey = 'signin_reloaded';
     const hasReloaded = localStorage.getItem(reloadKey);
     const isDriveID = sessionStorage.getItem('inviteDriveId')
      if(isDriveID){
        return; // Skip reload if inviteDriveId is present
      } 
     if (!hasReloaded) {
       // Set flag to prevent infinite reload loop
       localStorage.setItem(reloadKey, 'true');
       // Hard reload by adding timestamp to force fresh request bypassing cache
       const timestamp = Date.now();
       const separator = window.location.search ? '&' : '?';
       window.location.href =
         window.location.href + separator + 't=' + timestamp;
       return; // Stop further execution since we're reloading
     }
     // Optionally clear the flag to allow reload on future sessions
     localStorage.removeItem(reloadKey);
  }

  changeToManualLogin(){
   this.isLoginScreenVisible = !this.isLoginScreenVisible;
   this.profileForm.reset();
   this.otpSignIn.reset();
   this.signUpForm.reset();
    this.profileForm.get('phoneCode')?.setValue('+91');
    this.otpSignIn.get('phoneCode')?.setValue('+91');
    this.signUpForm.get('phoneCode')?.setValue('+91');
  }
  carouselSlides: any[] = [
    {
      title: 'Staffing, made simple',
      description:
        'Get personalized feedback to help you prepare confidently for client interviews',
      image: this.service.Images.STAFFING_CANDIDATE_CAORUSAL3,
      videoBackground: this.service.Images.CANDIDATE_CAROUSEL_1_BG_VIDEO,
      avatarImage: this.service.Images.CANDIDATE_CAROUSEL_1_AVATAR,
      blueThemeImage:
        this.service.Images.STAFFING_CANDIDATE_CAORUSAL3
    },
    {
      title: 'Staffing, made simple',
      description:
        'Showcase your expertise through structured, skill-based assessments beyond your profile',
      image: this.service.Images.CANDIDATE_CAROUSEL_2_BG_GIF,
      avatarImage: this.service.Images.CANDIDATE_CAROUSEL_2_AVATAR,
      avatarOffsetX: 20,
      blueThemeImage:
        this.service.Images.CANDIDATE_CAROUSEL_2_BG_GIF
    },
    {
      title: 'Discover talents for you',
      description:
        'Chat with the IQIGAI Buddy to showcase your skills, experience, and career aspirations',
       image: this.service.Images.STAFFING_CANDIDATE_CAORUSAL1,
      videoBackground: this.service.Images.CANDIDATE_CAROUSEL_1_BG_VIDEO,
      avatarImage: this.service.Images.CANDIDATE_CAROUSEL_3_AVATAR,
      avatarOffsetX: 20,
      blueThemeImage:
        this.service.Images.STAFFING_CANDIDATE_CAORUSAL1
    }
  ];

  goToSlide(index: number): void {
    this.currentSlide = index;
    this.playActiveVideo();
    this.resetActiveGif();
    this.startAutoPlay();
  }

  ngAfterViewInit(): void {
    // Trigger programmatic play for initial slide since [src] is bound after autoplay fires
    this.playActiveVideo();
    // Fallback: some browsers block autoplay until a user gesture — unlock on first interaction
    this.gestureUnlockHandler = () => {
      this.playActiveVideo();
      document.removeEventListener('pointerdown', this.gestureUnlockHandler);
    };
    document.addEventListener('pointerdown', this.gestureUnlockHandler);
  }

  private gestureUnlockHandler: () => void;

  ngOnDestroy(): void {
    this.stopAutoPlay();
    document.removeEventListener('pointerdown', this.gestureUnlockHandler);
  }

 readonly carouselIntervalMs = 6000;

 startAutoPlay() {
  this.stopAutoPlay();
  this.autoPlayInterval = setInterval(() => {
    this.currentSlide =
      (this.currentSlide + 1) % this.totalSlides;
    this.playActiveVideo();
    this.resetActiveGif();
    this.cd.detectChanges();
  }, this.carouselIntervalMs);
}

  playActiveVideo(): void {
    if (!this.carouselVideos) return;
    // QueryList only contains slides that have videoBackground — map slide index to QueryList index
    let videoIdx = 0;
    const slideToVideoIdx: Record<number, number> = {};
    this.carouselSlides.forEach((slide, i) => {
      if (slide.videoBackground) {
        slideToVideoIdx[i] = videoIdx++;
      }
    });
    const activeVideoIdx = slideToVideoIdx[this.currentSlide];
    this.carouselVideos.forEach((ref, i) => {
      const el = ref.nativeElement;
      if (i === activeVideoIdx) {
        el.muted = true;
        el.pause();
        el.currentTime = 0;
        el.onended = () => {
          // manually loop only while this slide is still active
          const currentActiveIdx = slideToVideoIdx[this.currentSlide];
          if (i === currentActiveIdx) {
            el.currentTime = 0;
            el.play().catch(() => {});
          }
        };
        const doPlay = () => el.play().catch(() => {});
        if (el.readyState >= 2) {
          doPlay();
        } else {
          el.load();
          const onCanPlay = () => {
            doPlay();
            el.removeEventListener('canplay', onCanPlay);
          };
          el.addEventListener('canplay', onCanPlay);
        }
      } else {
        el.onended = null;
        el.pause();
        el.currentTime = 0;
      }
    });
  }


get totalSlides(): number {
  return this.carouselSlides.length;
}

  resetActiveGif(): void {
    if (!this.carouselGifs) return;
    let gifIdx = 0;
    const slideToGifIdx: Record<number, number> = {};
    this.carouselSlides.forEach((slide, i) => {
      if (!slide.videoBackground) {
        slideToGifIdx[i] = gifIdx++;
      }
    });
    const activeGifIdx = slideToGifIdx[this.currentSlide];
    if (activeGifIdx === undefined) return;
    const el = this.carouselGifs.toArray()[activeGifIdx]?.nativeElement;
    if (!el) return;
    // clearing then reassigning src restarts GIF animation from frame 0 using browser cache
    const src = el.src;
    el.src = '';
    el.src = src;
  }

autoPlayInterval: ReturnType<typeof setInterval> | null = null;

stopAutoPlay(): void {
  if (this.autoPlayInterval) {
    clearInterval(this.autoPlayInterval);
    this.autoPlayInterval = null;
  }
}

  

}
